// extracted by mini-css-extract-plugin
export default {"section":"DialogsTable_section__t3I0f","toDialog":"DialogsTable_toDialog__4dFzS","link":"DialogsTable_link__ATy7F"};